import React, { useEffect, useState } from 'react';
import "./Slider.css";

import img1 from "../asset/5.png";
import img2 from "../asset/2.jpg";
import img3 from "../asset/6.jpg";

const images = [img1, img2, img3];

const SwiperSlider = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent(prev => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="slider-container">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index + 1}`}
            className={`slide ${index === current ? "active" : ""}`}
          />
        ))}

        <div className="dots">
          {images.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === current ? "active-dot" : ""}`}
            ></span>
          ))}
        </div>
      </div>

      <div className="marquee-container">
        <div className="marquee-text">
          EARN THE SALARY OF 53 LAC PER MONTH AFTER COMPLETING MASTERS DEGREE IN EUROPE COUNTRY
        </div>
      </div>
    </>
  );
};

export default SwiperSlider;
